import {array, Decoder, field, number, object} from 'json-bouncer'

export interface M<T, Filter> {
    readonly filters: Filter[]
    readonly data: T[]
    readonly totalCount: number
}

export function decoder<T, Filter>(
    filterDecoder: Decoder<Filter>,
    dataDecoder: Decoder<T>,
): Decoder<M<T, Filter>> {
    return object({
        filters: field('filters', array(filterDecoder)),
        data: field('data', array(dataDecoder)),
        totalCount: field('totalCount', number()),
    })
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Data/FilteredAndPaginated.ts